export default class CrudFiltering {

    constructor(name) {
        this.name = name
    }

    init(component) {
        this.vm = component
        this.restoreUiConfig()
    }

    listed() {
        this.saveUiConfig()
    }

    filteringValues(selectValues, withNone = false) {
        let values = Object.keys(selectValues).map(value => { 
            return {value, text: selectValues[value] }
        })
        .sort((a, b) => (a.text > b.text) ? 1 : -1)
        if (withNone) {
            values.unshift({text: this.vm.$t('common.none'), value: 'x'})
        }
        return values
    }

    unsortedFilteringValues(items, withNone = false) {
        let values = items.map(item => { 
            return { text: item.name, value: item.id }
        })
        if (withNone) {
            values.unshift({text: this.vm.$t('common.none'), value: 'x'})
        }
        return values
    }

    filterChange(data) {
        let prop = Object.keys(data)[0]
        if (data[prop].length > 0) {
            this.vm.filters[prop] = data[prop]
        } else {
            delete this.vm.filters[prop]
        }
        this.vm.filters = {...this.vm.filters}    // Clone to force reactivity
        this.vm.reload()
    }

    sortChange(data, defaultSort = null) {
        if (data.order == null) {
            if (defaultSort !== null) {
                this.vm.ctrl.query.sort = defaultSort
            } else {
                // Nothing, we don't know how to sort.
            }
        } else {
            const firstColumn = data.order == 'descending' ? '-' + data.prop : data.prop
            let columns = [firstColumn]
            if (defaultSort !== null) {
                columns = [firstColumn, ...defaultSort]
            }
            this.vm.ctrl.query.sort = columns
        }
        this.vm.ctrl.reload()
    }

    clearFilters(defaultFilter = {}, defaultSort = null) {
        this.vm.$refs.table.clearFilter()
        this.vm.$refs.table.clearSort()
        this.vm.$refs.search.clearFilter()
        this.vm.filters = {...defaultFilter}
        this.vm.search = ''
        if (defaultSort !== null) {
            this.vm.ctrl.query.sort = defaultSort
        }
        this.vm.reload()
    }

    saveUiConfig() {
        let data = { 
            filters: this.vm.filters,
            query: this.vm.ctrl.client.query,
            paging: this.vm.ctrl.paging
        }
        this.vm.$auth.setUiConfig(data, this.name)
    }

    restoreUiConfig() {
        let config = this.vm.$auth.getUiConfig(this.name)

        // Compatibility issue.
        if (this.name == 'dashboard_sessions' && config && config.query && config.query.include.includes('result_select')) {
            this.vm.$auth.resetUiConfig()
            return
        }

        if (config) {
            this.vm.filters = config.filters
            this.vm.ctrl.query = config.query
            this.vm.ctrl.client.query = config.query
            this.vm.ctrl.paging = config.paging
        }
    }
}
